/**
 * @generated SignedSource<<eae79da6c11db5acc8bbd81e5c67ef58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillAssessmentsByStudentFilterInput = {
  skillCode?: string | null | undefined;
  skillId?: string | null | undefined;
};
export type IndividualStudentReportAssessmentsQuery$variables = {
  filter: SkillAssessmentsByStudentFilterInput;
  studentId: string;
};
export type IndividualStudentReportAssessmentsQuery$data = {
  readonly skillAssessmentsByStudentId: {
    readonly nodes: ReadonlyArray<{
      readonly activityId: string | null | undefined;
      readonly id: string;
      readonly items: ReadonlyArray<{
        readonly duration: number | null | undefined;
        readonly id: string;
      } | null | undefined> | null | undefined;
      readonly publicUserId: string | null | undefined;
      readonly score: number;
      readonly sessionCompletedOn: any;
      readonly sessionId: any;
      readonly sessionLength: number;
      readonly skill: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type IndividualStudentReportAssessmentsQuery = {
  response: IndividualStudentReportAssessmentsQuery$data;
  variables: IndividualStudentReportAssessmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studentId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "studentId",
        "variableName": "studentId"
      }
    ],
    "concreteType": "StudentSkillAssessmentNodeConnection",
    "kind": "LinkedField",
    "name": "skillAssessmentsByStudentId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentSkillAssessmentNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "score",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionLength",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionCompletedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentSkillAssessmentItemNode",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "duration",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skill",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IndividualStudentReportAssessmentsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "IndividualStudentReportAssessmentsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "edcd94909e5c85c952423eb9b14b59f7",
    "id": null,
    "metadata": {},
    "name": "IndividualStudentReportAssessmentsQuery",
    "operationKind": "query",
    "text": "query IndividualStudentReportAssessmentsQuery(\n  $studentId: ID!\n  $filter: SkillAssessmentsByStudentFilterInput!\n) {\n  skillAssessmentsByStudentId(studentId: $studentId, filter: $filter) {\n    nodes {\n      id\n      score\n      sessionLength\n      sessionCompletedOn\n      sessionId\n      activityId\n      publicUserId\n      items {\n        id\n        duration\n      }\n      skill {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a237b7120b3ae284cef03e6258a33e7";

export default node;
